import { createStyles } from 'antd-style';

import { ThemeColors } from '../../theme';
import { flexCenter } from '../../styles/mixins';

export const useStepsWithContentStyles = createStyles(({ token }) => ({
  steps: {
    '&& .ant-steps-item-content': {
      ...flexCenter(),
      marginTop: 6,
      height: 40,
    },
  },
  stepsFaIcon: {
    '&&': {
      width: 30,
      height: 30,
      margin: 1,
      backgroundImage: `linear-gradient(180deg, ${ThemeColors.COLOR_RED3} 0%, ${ThemeColors.COLOR_RED4} 100%)`,
      border: `1px solid ${ThemeColors.COLOR_RED5}`,
      borderRadius: '100%',
      ...flexCenter(),
      color: token.colorWhite,
    },
  },
}));
